import { createSelector } from "reselect"
import { NORMALIZATION } from "helpers/segments"
import { getIsActive, getNormalization, getSelectedSubScreen } from "./index"
import { getSegment } from "./filters"

export const getAdjustedNormalizationProperties = createSelector(
  [getIsActive, getSelectedSubScreen, getSegment, getNormalization],
  (isActive, selectedSubScreen, segment, normalization) => {
    if (isActive && selectedSubScreen === "risk" && segment) {
      return {
        normalization: NORMALIZATION.STANDALONE,
        disableNormalization: true,
        disableNormalizationTooltip: "Segment normalization must be Standalone when active",
        isNormalizationAdjusted: true,
      }
    }

    return {
      normalization,
      disableNormalization: false,
      isNormalizationAdjusted: false,
    }
  },
)
